import React from "react";

import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";

import { NewAppHeader } from "views/MyApps/NewAppHeader";
import { NewAppContent } from "views/MyApps/NewAppContent";

export function CreateApp(props) {
  return (
    <GridContainer>
      <GridItem md={2}>&nbsp;</GridItem>
      <GridItem md={10}>
        <NewAppHeader />
      </GridItem>
      <GridItem md={12}>
        <NewAppContent
          user={props.user}
          registerApp={props.registerApp}
          registerButtonDisabled={props.registerButtonDisabled}
          setRegisterButtonDisabled={props.setRegisterButtonDisabled}
          setCrudState={props.setCrudState}
        />
      </GridItem>
    </GridContainer>
  );
}
